<template>
    <div class="child-section">
        <div class="tableau-section" style="border-bottom: 1px solid #4cb3c1">
            <div :class="$mq">
                <div class="subtitle-section-detail project-information"  :class="$mq">
                {{ $t("rapportedit.sections.numero_naff") }}
                    <div class="cell-detail" >
                        <a-input style="width:100%" :maxLength="10" :disabled="is_locked_report" v-model="informations.naff"/>
                    </div>
                </div>
                <div class="subtitle-section-detail project-information"  :class="$mq">
                     {{ $t("rapportedit.sections.nom_projet") }}
                     <div class="cell-detail" >
                        <a-input style="width:100%" :disabled="is_locked_report" v-model="informations.operation_name"/>
                    </div>
                </div>
                <div class="subtitle-section-detail project-information"  :class="$mq" >
                    {{ $t("rapportedit.sections.nom_csps") }}
                      <div class="cell-detail" >
                    <a-input  :disabled="is_locked_report" v-model="informations.name"/>
                    </div>
                </div>
                <div class="subtitle-section-detail project-information"  :class="$mq">
                    {{ $t("rapportedit.sections.email_csps") }}
                     <div class="cell-detail"  >
                        <a-input :class="errorMail?'error':''" :disabled="is_locked_report" v-model="informations.email"  @change="reset_error" @blur="test_mail"/>
                    </div>
                </div>
            </div>
        </div>
      
    </div>
</template>
<script>
import _ from "lodash";
import {mapActions,mapGetters} from 'vuex';


export default {
    name: "ProjectInformation",
    props: {
        value:{
            type:Object,
            required:true
        }
	},
    data() {
        return {
            errorMail:false,
            textError:"Information Projet : Email CSPS remplacé invalide",
            valueChange:false,
            informations:{},
        };
    },
    watch:{
        informations:{
            deep:true,
            handler(){
                if(!this.valueChange){
                    this.$emit('input',this.informations);
                    this.$emit('save');
                }
                this.valueChange=false;
                
            }
        },
        value:{
            immediate:true,
            deep:true,
            handler(){
                this.valueChange=true;
                this.informations={...this.value};
            }
        }
    },
    beforeMount(){
         this.remove_blocked_sign_error(0)
         if(this.informations.email!='' && !this.getValideEmail(this.informations.email)){
                this.add_blocked_sign_error({id:0,text:this.textError})
                this.errorMail=true;
        }
    },
    methods: {
        ...mapActions('rapports',["add_blocked_sign_error","remove_blocked_sign_error"]),
        test_mail(){
            if(!this.getValideEmail(this.informations.email)){
                this.$notification["error"]({message: "L'adresse email renseignée est invalide"});
                this.add_blocked_sign_error({id:0,text:this.textError})
                this.errorMail=true;
            }
            this.$emit('save')
        },
        reset_error(){
            this.errorMail=false;
            this.remove_blocked_sign_error(0)
        }
    },
    computed: {
        ...mapGetters("rapports", { is_locked_report: "is_locked_report" }),
        ...mapGetters(["getValideEmail"]),
  }
};
</script>